module.exports = __webpack_public_path__ + "img/pic2.4b26d277.png";